import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useMapsApiKey, useMounted } from '@fullstory/react-hooks';
import { MapsAsyncActions } from './actions';
import { isLocalDev } from '@fullstory/util/domains';
import { AppDispatch } from '../../types';

export const useLocationMapImage = (latLong?: string) => {
  const dispatch = useDispatch<AppDispatch>();
  const apiKey = useMapsApiKey();
  const [img, setImg] = useState<string>();
  const mounted = useMounted();
  useEffect(() => {
    if (latLong && apiKey && !isLocalDev()) {
      dispatch(MapsAsyncActions.requestImgUrl(latLong, apiKey))
        .then(([_, imgUrl]) => mounted() && setImg(imgUrl))
        .catch(() => {
          console.warn('unable to load location map');
        });
    }
  }, [dispatch, latLong, apiKey, mounted]);

  return img;
};
